import React from "react";
import "./skills.css";
import { i18n } from "../translate/i18n";

export const Backend = () => {
  return (
    <div className="skills__content">
      <h3 className="skills__title">{i18n.t("back.title")}</h3>
      <div className="skills__box">
        <div className="skills__group">
          <div className="skills__data">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Node Js</h3>
              <span className="skills__level">{i18n.t("back.level")}</span>
            </div>
          </div>
          <div className="skills__data">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Python</h3>
              <span className="skills__level">{i18n.t("back.level")}</span>
            </div>
          </div>
        </div>
        <div className="skills__group">
          <div className="skills__data">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">MySql</h3>
              <span className="skills__level">{i18n.t("back.level")}</span>
            </div>
          </div>
          <div className="skills__data">
            <i className="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">SQL</h3>
              <span className="skills__level">{i18n.t("back.level")}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
